type getAvailabilityTextParams = {
    aggregatedMainChannelQuantity?: number;
    deliveryFromFactory?: boolean;
    procuredProduct?: boolean;
};

export const getAvailabilityText = ({
    aggregatedMainChannelQuantity,
    deliveryFromFactory,
    procuredProduct
}: getAvailabilityTextParams): string => {
    if (aggregatedMainChannelQuantity) {
        return 'Online Verfügbar';
    }

    if (deliveryFromFactory) {
        return 'Lieferung ab Werk';
    }

    if (procuredProduct) {
        return 'Beschaffungsware';
    }

    return 'Wird für Sie zur Lieferung bestellt';
};
